// components/Navbar.jsx

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { HiMenu, HiX } from 'react-icons/hi';

export default function Navbar() {
  const user = auth.currentUser;
  const navigate = useNavigate();
  const location = useLocation();
  const [accessType, setAccessType] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const fetchAccessType = async () => {
      if (!auth.currentUser) return;
      const userRef = doc(db, 'users', auth.currentUser.uid);
      const snap = await getDoc(userRef);
      if (snap.exists()) {
        const data = snap.data();
        setAccessType(data.accessType || 'demo');
      }
    };
    fetchAccessType();
  }, []);

  const handleLogout = () => {
    auth.signOut().then(() => {
      setTimeout(() => {
        navigate('/');
      }, 200);
    });
  };

  const linkClass = path =>
    `block px-3 py-2 rounded ${
      location.pathname === path
        ? 'bg-purple-100 text-purple-700'
        : 'text-gray-700 hover:bg-purple-50 hover:text-purple-700'
    }`;

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <Link to="/home" className="flex items-center space-x-2">
            <img src="/assets/BrainyBuddy.png" alt="Brainy Buddy Logo" className="w-14 h-14" />
            <span className="text-2xl font-bold text-purple-700">Brainy Buddy</span>
          </Link>

          {/* Desktop Links */}
          <div className="hidden md:flex space-x-2 items-center">
            <Link to="/home" className={linkClass('/home')}>Home</Link>
            <Link to="/leaderboard" className={linkClass('/leaderboard')}>🏆 Leaderboard</Link>
            <Link to="/profile" className={linkClass('/profile')}>🏆 Profile</Link>
            {accessType === 'demo' ? (
              <Link to="/upgrade" className={linkClass('/upgrade')}>Upgrade</Link>
            ) : (
              <Link to="/badges" className={linkClass('/badges')}>🏅 Hall Of Honour</Link>
            )}
            <Link to="/contact" className={linkClass('/contact')}>Contact</Link>
            {user ? (
              <button
                onClick={handleLogout}
                className="px-3 py-2 text-purple-600 hover:underline"
              >
                Logout
              </button>
            ) : (
              <Link to="/login" className="px-3 py-2 text-purple-600 hover:underline">Login</Link>
            )}
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2 rounded hover:bg-gray-100"
            onClick={() => setMobileOpen(o => !o)}
          >
            {mobileOpen ? <HiX size={24} /> : <HiMenu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Panel */}
      <div className={`${mobileOpen ? 'block' : 'hidden'} md:hidden bg-white border-t`}> 
        <Link to="/home" onClick={() => setMobileOpen(false)} className={linkClass('/home')}>Home</Link>
        <Link to="/leaderboard" onClick={() => setMobileOpen(false)} className={linkClass('/leaderboard')}>🏆 Leaderboard</Link>
        <Link to="/profile" onClick={() => setMobileOpen(false)} className={linkClass('/profile')}>🏆 Profile</Link>
        {accessType === 'demo' ? (
          <Link to="/upgrade" onClick={() => setMobileOpen(false)} className={linkClass('/upgrade')}>Upgrade</Link>
        ) : (
          <Link to="/badges" onClick={() => setMobileOpen(false)} className={linkClass('/badges')}>🏅 Hall Of Honour</Link>
        )}
        <Link to="/contact" onClick={() => setMobileOpen(false)} className={linkClass('/contact')}>Contact</Link>
        {user ? (
          <button
            onClick={() => { setMobileOpen(false); handleLogout(); }}
            className="block w-full text-left px-3 py-2 text-purple-600 hover:underline"
          >
            Logout
          </button>
        ) : (
          <Link to="/login" onClick={() => setMobileOpen(false)} className="block px-3 py-2 text-purple-600 hover:underline">
            Login
          </Link>
        )}
      </div>
    </nav>
  );
}
